import { Dispatch, FC, SetStateAction, useEffect } from "react";

import { Control, FieldValues } from "react-hook-form";
import { Trans, useTranslation } from "react-i18next";

import TextField from "../TextField/TextField";
import Typography from "../Typography";

import { Col, Row, Seperator } from "../Flex";

import { DIGIPOSTHEME } from "theme/digiPosTheme";
import { useMediaQuery } from "context/media/MediaContext";

import { StyledOuterContainer } from "./OtpTextField.styles";

interface OtpTextProps {
  name?: string;
  label?: string;
  control: Control<FieldValues>;
  timer: number;
  setTimer: Dispatch<SetStateAction<number>>;
  minutes: number;
  setMinutes: Dispatch<SetStateAction<number>>;
  seconds: number;
  setSeconds: Dispatch<SetStateAction<number>>;
  timeDiff: string;
  setTimeDiff: Dispatch<SetStateAction<string>>;
  error?: string;
  onError?: (clientHeight?: number) => void;
}

const OtpTextField: FC<OtpTextProps> = ({
  name = "",
  timer,
  setTimer,
  minutes,
  setMinutes,
  seconds,
  setSeconds,
  timeDiff,
  setTimeDiff,
  control,
  label,
  error,
  onError,
}) => {
  const { isMobile } = useMediaQuery();
  const { t } = useTranslation();

  useEffect(() => {
    let timerId: NodeJS.Timeout;
    timerId = setTimeout(() => {
      if (seconds && seconds > 0) {
        setSeconds(seconds - 1);
      } else {
        setMinutes(minutes - 1);
        setSeconds(59);
      }

      if (timer > 0) {
        setTimer(timer - 1);
        setTimeDiff(`
          ${minutes.toString().padStart(2, "0")} 
          : 
          ${seconds.toString().padStart(2, "0")}
        `);
      }
    }, 1000);

    return () => clearInterval(timerId);
  }, [setMinutes, minutes, setSeconds, seconds, setTimer, timer]);

  return (
    <StyledOuterContainer>
      <Row justifyContent='flex-start' noMargin backgroundColor='transparent'>
        <Col>
          <TextField
            control={control}
            disabled={timer === 0}
            error={error}
            label={label}
            maxLength={6}
            name={name}
            onError={onError}
            type='numeric'
            placeholder={t("otp_validation") || ""}
          />
        </Col>

        {/* {isMobile && <Seperator marginRight={20} />} */}
      </Row>

      {timer > 0 && (
        <Row isResponsive noMargin backgroundColor='transparent'>
          <Typography
            letterSpacing='0.4px'
            line-height='1.33'
            margin={isMobile ? "16px 0px 24px 0px" : "16px 0px 40px 0px"}
            size='12px'
            variant='span'
            weight='500'
          >
            <Trans
              i18nKey='otp_text_field_remaining_time'
              values={{ timeDiff }}
            />
            <Typography
              color={DIGIPOSTHEME.colors.secondaryAkbankBlack}
              letterSpacing='0.4px'
              line-height='1.33'
              margin='3px'
              size='12px'
              variant='span'
              weight='bold'
            />
          </Typography>
        </Row>
      )}
    </StyledOuterContainer>
  );
};

export default OtpTextField;
